// components/CodeBlock.jsx
import { useEffect, useRef } from 'react'
import Prism from 'prismjs'

import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-sql'
import 'prismjs/components/prism-toml'
import 'prismjs/themes/prism-tomorrow.css'

export default function CodeBlock({
  code = '',
  language = 'javascript',
  className = '',
}) {
  const ref = useRef(null)

  useEffect(() => {
    if (ref.current) Prism.highlightElement(ref.current)
  }, [code, language])

  return (
    <pre className='text-xs'>
      <code ref={ref} className={`language-${language} ${className}`}>
        {code}
      </code>
    </pre>
  )
}
